<template>
  <div class="mt-5">
    <template v-if="isMCA">
      <div class="text-center">
        <img
          src="@/assets/img/fallido.png"
          alt="pago-fallido"
        />
        <h1 class="text-xl">
          ¡Tu pago no pudo completarse con éxito!
        </h1>
      </div>
      <hr />
      <div class="text-left">
        <p class="text-danger">
          Transacción Fallida
        </p>
        <p>Motivo del fallo:</p>
        <p>{{ message }}</p>
      </div>
      <div>
        <button
          class="button"
          @click="goBack"
        >
          Intentar de nuevo
        </button>
      </div>
    </template>
    <template
      v-else
    >
      <h1
        class="text-3xl text-danger mb-4"
        name="estimated"
      >
        {{ $t('text.dearUser') }}
      </h1>
      <p class="text-3xl text-danger">
        {{ message }}
      </p>
      <p>
        <button
          class="button"
          name="return"
          @click="goBack"
        >
          {{ $t('text.goBack') }}
        </button>
      </p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BuyError',
  computed: {
    ...mapGetters(['isMCA']),
    message() {
      const defaultError = 'DECLINED_TRANSACTION';
      const error = this.$route.query.error || defaultError;
      return this.$t(`error.${error}`);
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'SetNumber' });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
